import { gql } from '@apollo/client';

export const TOGGLE_STORE_MODULE = gql(/* GraphQL */ `
    mutation ToggleStoreModule($input: ToggleModuleInput!) {
        toggleStoreModule(input: $input) {
            successful
        }
    }
`);
